// extracted by mini-css-extract-plugin
export default {"dmvPage":"DMVPage_dmvPage__byItZ","title":"DMVPage_title__vSNEt","section":"DMVPage_section__7xD6f","subTitle":"DMVPage_subTitle__MQYRh","text":"DMVPage_text__TNymA"};